module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABSUlEQVR4AeyWQWoCMRSG/6SFupgDdNGjuGuhvUW7ENreqC0u7C0UdOdRXHiAWShonvOURByIhLyIA76B54RJ3j8fn7N4Fh2/bguw91M/P/zVryX/lGIGGcwamt4RjRm0FGQxQEN4DFAGT2EtXBQDFHJE2xUwqiZxQw0miooeU4NRNYkbajBRVPSYGoyqSdxQg4miosdODPKY1Put33MKoP7xLdTPyeAeHtuOOUAA5A2e5yxolFcY+OAmdJCXQaP2PNlkHWKNw+awuv4vEe49RQBcfVWzrTNvDuYjrzD0oc7RMC+jeTeZl/V3NfFZAZAf8Mbqs/rPKcDM4S9r5zkZ+55GlI/h+wkgP+ha3Qrg5byrQalbNagGpQak/foNqkGpAWl/uW+QsPAw5LD0a+m9GGCYJ1vzXGcAGWQ/T7bmOX4uqWIGJRDnencAAAD//40HXKYAAAAGSURBVAMA9VsKYNBuxXgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tianjia_20@2x.png
// module id = 726
// module chunks = 1